module.exports = __webpack_public_path__ + "static/media/error.b0db16e7.mp3";